import React, { useState } from "react";
import clsx from "clsx";
import Map from "./components/Mapa";
import Filters from "./components/Filters";
import Post from "./components/Post";

const App = ({ posts }) => {
  const [filteredPosts, setFilteredPosts] = useState(posts);
  const [selectedPost, setSelectedPost] = useState(null);

  return (
    <div className={clsx("mm-map-container")}>
      <Filters posts={posts} setFilteredPosts={setFilteredPosts}>
        <Map posts={filteredPosts} setSelectedPost={setSelectedPost} />
      </Filters>
      <Post post={selectedPost} />
    </div>
  );
};

export default App;
